import React, { useState } from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CTALink } from '@components/CTALink';
import { JoykitColor } from '@components/themes';
import { Columns } from '@components/Columns';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import {
  RSVPTextPairing,
  RsvpPlaceholderCloudImage,
  StyledImageContainer,
  StyledPlaceholderCloudImage,
  StyledText,
  FeatureText,
} from './RsvpMadeEasySection.styles';
import { useTranslation } from 'react-i18next';

interface RsvpMadeEasySectionProps {
  titleColor: JoykitColor;
  bodyColor: JoykitColor;
  backgroundColor: JoykitColor;
}

export const RsvpMadeEasySection: React.FC<RsvpMadeEasySectionProps> = ({ titleColor, bodyColor, backgroundColor }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('weddingWebsitePage');
  const rsvpMadeEasyData = t('sections.rsvpMadeEasy');
  return (
    <Box as={'section'} backgroundColor={backgroundColor} paddingTop={[9, 12]} paddingBottom={[10, 7]} id="Wedding_Websites_RSVP_Cross">
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <div />
      </LazyLoadWrapper>
      <Columns>
        <Columns.Column width="full">
          <Flex
            alignItems={'center'}
            flexDirection={'column'}
            style={{ maxWidth: 780, marginLeft: 'auto', marginRight: 'auto' }}
            marginBottom={[12]}
          >
            <RSVPTextPairing
              title={rsvpMadeEasyData.title}
              body={rsvpMadeEasyData.content}
              titleTagName={'h2'}
              alignment={'center'}
              titleColor={titleColor}
              titleVariant={'hed96Break'}
              bodyColor={bodyColor}
              bodyVariant={'dek24'}
              marginBottom={[7, 9]}
            />
            <CTALink id="rsvpMadeEasy" hasChevron typography="featureHed20" href="/online-rsvp/">
              {rsvpMadeEasyData.getStartedCTAText}
            </CTALink>
          </Flex>
        </Columns.Column>
      </Columns>

      <Columns>
        <Columns.Column width="half">
          <RsvpPlaceholderCloudImage
            resizeWidth={600}
            src={rsvpMadeEasyData.image}
            alt="Rsvp Plusone"
            width="100%"
            isMainSrcShown={isVisible}
            optimization="default"
          />
        </Columns.Column>
        <Columns.Column width="half">
          <Columns multiline>
            {rsvpMadeEasyData.tabsData.map((tabData, index) => (
              <Columns.Column key={index} width={6}>
                <StyledText alignItems="left" flexDirection="column" marginBottom={11}>
                  <StyledImageContainer>
                    <StyledPlaceholderCloudImage
                      alt={tabData.content.title}
                      src={tabData.content.image}
                      width={40}
                      height={40}
                      isMainSrcShown={isVisible}
                      optimization="default"
                    />
                  </StyledImageContainer>
                  <FeatureText
                    alignment="left"
                    title={tabData.content.title}
                    titleVariant="featureHed17"
                    titleColor="neutra6"
                    body={tabData.content.description}
                    bodyVariant="featureCopy17"
                    bodyColor="neutra5"
                    bodyTagName="p"
                  />
                </StyledText>
              </Columns.Column>
            ))}
          </Columns>
        </Columns.Column>
      </Columns>
    </Box>
  );
};
